import $ from 'jquery';
import cookie from 'jquery.cookie';

export default function avviso() {
  
  function init() {
    //se ho il cookie al caricamento della pagina
    if ($.cookie('avviso') == 'nascondi') {
      $('#avviso').hide();
    }
    
    $('#btn-avviso .shortcut__link').on('click', function(e) {
      e.preventDefault();
      $('#avviso').show();
      //rimuovo il cookie
      $.removeCookie('avviso', { path: '/' });
    });
    
    $('#avviso .avviso__btn').on('click', function(e) {
      e.preventDefault();
      $('#avviso').hide();
      //setto il cookie
      $.cookie('avviso', 'nascondi', { path: '/' });
    });
  }

  
  $( document ).ready(function() {
    if($('#avviso').length > 0) {
      init();
    }
  });
}


// WEBPACK FOOTER //
// ./src/assets/js/avviso.js